__turbopack_context__.v({
  "brandSection": "_3hUVsW_brandSection",
  "container": "_3hUVsW_container",
  "copyright": "_3hUVsW_copyright",
  "footer": "_3hUVsW_footer",
  "footerActions": "_3hUVsW_footerActions",
  "heart": "_3hUVsW_heart",
  "logo": "_3hUVsW_logo",
  "logoLink": "_3hUVsW_logoLink",
  "navLink": "_3hUVsW_navLink",
  "navLinks": "_3hUVsW_navLinks",
});
